import { useState } from "react";
import { MapPin } from "lucide-react";
import { SITE } from "../data/content";

export default function MapEmbed() {
  const [show, setShow] = useState(false);

  if (show) {
    return (
      <iframe
        title="Map showing Elk Creek Marina location"
        src="https://www.google.com/maps?q=22911+W+877+Rd,+Park+Hill,+OK+74451&output=embed"
        width="100%"
        height="420"
        loading="lazy"
        style={{ border: 0 }}
        referrerPolicy="strict-origin-when-cross-origin"
        data-testid="contact-map-iframe"
      />
    );
  }

  return (
    <div className="h-[420px] bg-[var(--ec-foam)] flex flex-col items-center justify-center text-center px-6">
      <MapPin className="w-8 h-8 text-[var(--ec-lake)]" />
      <p className="mt-4 font-display text-2xl text-[var(--ec-navy)]">{SITE.address}</p>
      <p className="mt-2 text-sm text-[var(--ec-charcoal)]/80 max-w-md">
        The map is provided by Google, which may set cookies when it loads.
      </p>
      <div className="mt-6 flex flex-wrap gap-3 justify-center">
        <button
          type="button"
          onClick={() => setShow(true)}
          data-testid="contact-map-load-button"
          className="inline-flex items-center gap-2 bg-[var(--ec-navy)] text-white hover:bg-[var(--ec-lake)] font-semibold px-6 py-3 rounded-full btn-lift"
        >
          Show map
        </button>
        <a
          href={SITE.directions}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-map-directions-link"
          className="inline-flex items-center gap-2 border border-[var(--ec-navy)] text-[var(--ec-navy)] hover:bg-[var(--ec-navy)] hover:text-white font-semibold px-6 py-3 rounded-full btn-lift"
        >
          Get Directions<span className="sr-only"> (opens in new tab)</span>
        </a>
      </div>
    </div>
  );
}
